import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptCommonUserModule } from "@common/user/adapt-common-user.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleModule } from "@common/ux/collapsible/collapsible.module";
import { AdaptCollapsibleDashboardElementModule } from "@common/ux/collapsible-dashboard-element/collapsible-dashboard-element.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptActivitiesSharedModule } from "@org-common/lib/activities/activities-shared.module";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { PeerCatchupAuthService } from "@org-common/lib/peer-catchup/peer-catchup-auth.service";
import { DxAccordionModule, DxChartModule, DxDataGridModule, DxDateBoxModule, DxSelectBoxModule, DxSliderModule } from "devextreme-angular";
import { AdaptDirectorySharedModule } from "../directory-shared/directory-shared.module";
import { AdaptMeetingsSharedModule } from "../meetings/meetings-shared.module";
import { AdaptTeamDashboardSharedModule } from "../teams/team-dashboard-shared/team-dashboard-shared.module";
import { AdaptTeamsSharedModule } from "../teams/teams-shared.module";
import { CatchupGridComponent } from "./catchup-grid/catchup-grid.component";
import { CatchupHistoryChartComponent } from "./catchup-history-chart/catchup-history-chart.component";
import { CatchupHistoryChartDialogComponent } from "./catchup-history-chart-dialog/catchup-history-chart-dialog.component";
import { CatchupLinkComponent } from "./catchup-link/catchup-link.component";
import { CatchupRatingCellComponent } from "./catchup-rating-cell/catchup-rating-cell.component";
import { CatchupRelationshipsFilterComponent } from "./catchup-relationships-filter/catchup-relationships-filter.component";
import { CatchupRelationshipsGraphComponent } from "./catchup-relationships-graph/catchup-relationships-graph.component";
import { CatchupTrafficLightRatingComponent } from "./catchup-traffic-light-rating/catchup-traffic-light-rating.component";
import { CatchupViewsComponent } from "./catchup-views/catchup-views.component";
import { CatchupsPageContentComponent } from "./catchups-page-content/catchups-page-content.component";
import { DisplayCatchupRatingComponent } from "./display-catchup-rating/display-catchup-rating.component";
import { DisplayCatchupVisibilityComponent } from "./display-catchup-visibility/display-catchup-visibility.component";
import { DisplayFacilitatorCommentComponent } from "./display-facilitator-comment/display-facilitator-comment.component";
import { DisplayMissingCatchupComponent } from "./display-missing-catchup/display-missing-catchup.component";
import { DisplayRatingValueComponent } from "./display-rating-value/display-rating-value.component";
import { EditCatchupPeopleComponent } from "./edit-catchup-people/edit-catchup-people.component";
import { EditCatchupRatingComponent } from "./edit-catchup-rating/edit-catchup-rating.component";
import { EditCatchupRatingTypeComponent } from "./edit-catchup-rating-type/edit-catchup-rating-type.component";
import { LinkedNodesGraphComponent } from "./linked-nodes-graph/linked-nodes-graph.component";
import { MyCatchupsPageComponent } from "./my-catchups-page/my-catchups-page.component";
import { myCatchupsPageRoute, personalCatchupsPageRoute } from "./my-catchups-page/my-catchups-page.route";
import { RecordCatchupDialogComponent } from "./record-catchup-dialog/record-catchup-dialog.component";
import { SelectCatchupTeamComponent } from "./select-catchup-team/select-catchup-team.component";
import { ShowCatchupDialogComponent } from "./show-catchup-dialog/show-catchup-dialog.component";
import { TeamCatchupsPageComponent } from "./team-catchups-page/team-catchups-page.component";
import { teamCatchupsPageRoute } from "./team-catchups-page/team-catchups-page.route";


@NgModule({
    declarations: [
        CatchupLinkComponent,
        ShowCatchupDialogComponent,
        CatchupHistoryChartDialogComponent,
        EditCatchupRatingTypeComponent,
        CatchupHistoryChartComponent,
        DisplayCatchupRatingComponent,
        SelectCatchupTeamComponent,
        DisplayCatchupVisibilityComponent,
        DisplayRatingValueComponent,
        EditCatchupRatingComponent,
        CatchupTrafficLightRatingComponent,
        MyCatchupsPageComponent,
        CatchupsPageContentComponent,
        CatchupViewsComponent,
        CatchupRelationshipsGraphComponent,
        CatchupGridComponent,
        CatchupRelationshipsFilterComponent,
        LinkedNodesGraphComponent,
        CatchupRatingCellComponent,
        TeamCatchupsPageComponent,
        RecordCatchupDialogComponent,
        EditCatchupPeopleComponent,
        DisplayMissingCatchupComponent,
        DisplayFacilitatorCommentComponent,
    ],
    imports: [
        CommonModule,
        AdaptDateModule,
        DxChartModule,
        AdaptDirectorySharedModule,
        AdaptLinkDisabledModule,
        DxAccordionModule,
        AdaptTooltipModule,
        AdaptHtmlEditorModule,
        AdaptMeetingsSharedModule,
        DxDateBoxModule,
        AdaptButtonModule,
        AdaptCommonDialogModule,
        AdaptTeamDashboardSharedModule,
        AdaptLoadingSpinnerModule,
        AdaptTeamsSharedModule,
        AdaptCommonUserModule,
        AdaptShellModule,
        DxSelectBoxModule,
        FormsModule,
        DxSliderModule,
        DxDataGridModule,
        AdaptCollapsibleDashboardElementModule,
        AdaptCollapsibleModule,
        AdaptActivitiesSharedModule,
    ],
    exports: [
        CatchupLinkComponent,
        EditCatchupRatingTypeComponent,
        CatchupsPageContentComponent,
        SelectCatchupTeamComponent,
    ],
})
export class AdaptPeerCatchupModule {
    public static readonly Routes = [
        ...personalCatchupsPageRoute.routes,
        ...myCatchupsPageRoute.routes,
        ...teamCatchupsPageRoute.routes,
    ];

    constructor(authorisationService: AuthorisationService) {
        PeerCatchupAuthService.registerAccess(authorisationService);
    }
}
